module.exports = __webpack_public_path__ + "media/images/v4/cta-bg-059c82ee7383d188437cde6db174febf.png";